"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The response of TopicUpdate ADD_AND_SET_TOPIC service
 */
var AddTopicResult = /** @class */ (function () {
    /**
     * Create a new AddAndSetTopicRequest instance
     *
     * @param result  topic creation result
     */
    function AddTopicResult(result) {
        this.result = result;
    }
    return AddTopicResult;
}());
exports.AddTopicResult = AddTopicResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/add-topic-result.js
// module id = 1663
// module chunks = 1